var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTashi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3765 28.1743C56.3765 12.7175 43.7548 0.180908 28.1836 0.180908C12.6124 0.180908 0 12.7175 0 28.1743C0 38.3858 5.51499 47.3047 13.736 52.1965C14.1854 52.4662 14.6442 52.7173 15.1124 52.9591C15.1311 52.9591 15.1498 52.9777 15.1686 52.987C15.6086 53.2195 16.0674 53.4334 16.5262 53.6473C16.5637 53.6659 16.5918 53.6752 16.6292 53.6938C17.088 53.8984 17.5656 54.0937 18.0337 54.2797C18.0431 54.2797 18.0618 54.2891 18.0712 54.2891C18.5674 54.4751 19.0731 54.6518 19.5787 54.8192C20.9738 53.1544 22.1442 51.3688 23.0899 49.4902C27.4813 40.8318 27.1068 30.3877 21.9476 22.0362H34.4383C29.2791 30.3784 28.9045 40.8318 33.2959 49.4902C34.2416 51.3595 35.412 53.1544 36.8072 54.8192C37.3222 54.6611 37.8184 54.4751 38.324 54.2891C38.3334 54.2891 38.3428 54.289 38.3615 54.2797C38.839 54.0937 39.3072 53.8984 39.766 53.6938C39.8034 53.6752 39.8315 53.6659 39.869 53.6473C40.3278 53.4427 40.7772 53.2195 41.2267 52.987C41.2454 52.9777 41.2641 52.9684 41.2828 52.9591C41.751 52.7173 42.2098 52.4569 42.6592 52.1965C50.8802 47.3047 56.3952 38.3858 56.3952 28.1743H56.3765ZM17.3596 47.2768C10.6461 43.5102 6.10488 36.3584 6.10488 28.1743C6.10488 24.0636 7.2472 20.2227 9.23222 16.9304L13.4925 21.162C20.5993 28.2208 21.8821 38.8973 17.3502 47.2675L17.3596 47.2768ZM9.84084 15.9911C13.8109 10.1227 20.5525 6.24459 28.1836 6.24459C35.8147 6.24459 42.5656 10.1134 46.5263 15.9911H9.84084ZM39.0076 47.2768C34.4757 38.9066 35.7585 28.2301 42.8652 21.1713L47.1255 16.9397C49.1106 20.232 50.2529 24.0729 50.2529 28.1836C50.2529 36.3677 45.7117 43.5195 38.9982 47.2861L39.0076 47.2768Z",
    fill: "url(#paint0_linear_4044_21556)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4044_21556",
    x1: 6.60113,
    y1: 10.1785,
    x2: 49.5335,
    y2: 46.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#8B5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#AB8327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E7CC6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE98B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFDD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3922E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4044_21556",
    x1: 144.625,
    y1: 13.8615,
    x2: 149.261,
    y2: 17.7799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3922E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTashi);
export default __webpack_public_path__ + "static/media/tashi.0632423feb20e695a8044bfc9fda94e5.svg";
export { ForwardRef as ReactComponent };